export interface CheckinSessionParams {
  confirmationNumber: string;
  departureAirport: string;
  searchType?: string;
  eTicketNumber?: string;
  skymilesNumber?: string;
  lastName?: string;
  startFrom?: string;
}

export interface CheckinSessionData {
  searchType: string;
  confirmationNumber: string;
  eTicketNumber?: string;
  skymilesNumber?: string;
  creditcardType?: string;
  lastName: string;
  departureAirport: string;
  startFrom: string;
  deepLinkFlow: string;
}

export interface UserSessionData {
  lastName?: string;
  smNumber?: string;
  firstName?: string;
}
